const Subnav = function () {
    const selelctor = 'subnav__submenu-link';
    let elements = null;
    /**
     * Pseudo constructor
     * @private
     */
    const __construct = () => {
        document.addEventListener('click', onSubmenuClick);
    };
    /**
     * Stuff to do when a submenu link is clicked.
     *
     * @param {Event|MouseEvent} e
     */
    const onSubmenuClick = e => {
        elements = document.querySelectorAll(`.${selelctor}`);
        if (!elements.length) {
            return;
        }
        let clickedEl = Array.from(elements).find(node => node.isEqualNode(e.target) || node.contains(e.target));
        if (!clickedEl) {
            return;
        }
        let parentEl = e.target.closest('.subnav__item');
        if (!parentEl) {
            return;
        }
        let action = isActive(parentEl) ? 'remove' : 'add';
        parentEl.classList[action]('expanded');
    };
    /**
     *
     * @param {HTMLElement} el
     * @returns {boolean}
     */
    const isActive = el => {
        return el.classList.contains('expanded');
    };
    __construct();
};
export default Subnav;
